<script lang="ts">
    import {onMount} from "svelte";
    import {EnvStore} from "../../store/EnvStore";
    import HeaderSPView from "./HeaderSPView.svelte";
    import HeaderPCView from "./HeaderPCView.svelte";
    import osType = EnvStore.osType;

    $: osType = EnvStore.osType;
    $: isSmartPhone = (() => {
        return EnvStore.isSmartPhone($osType);
    })();

    onMount(() => {

    });


</script>

{#if isSmartPhone}

    <HeaderSPView/>

{:else}

    <HeaderPCView/>

{/if}

<style lang="scss">


</style>